/**
 * Pack-desk keyboard: Enter prints the selection, / focuses Find & print.
 * Ignore Enter when a control already owns it (buttons, fields, menus).
 */

const TYPING_SELECTOR = 'input, textarea, select, [contenteditable="true"]';
const ACTION_SELECTOR = `${TYPING_SELECTOR}, button, a, summary, [role="button"], [role="tab"], [role="menuitem"]`;

export function isPackDeskTypingTarget(target) {
  return target instanceof HTMLElement && Boolean(target.closest(TYPING_SELECTOR));
}

export function isPackDeskActionTarget(target) {
  return target instanceof HTMLElement && Boolean(target.closest(ACTION_SELECTOR));
}

export function packDeskShortcut(event) {
  if (!event || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) {
    return null;
  }
  if (event.key === '/' && !isPackDeskTypingTarget(event.target)) {
    return 'find';
  }
  if (event.key === 'Enter' && !isPackDeskActionTarget(event.target)) {
    return 'print';
  }
  return null;
}
